import React from 'react';
import styled from '@emotion/styled';

export interface FooterProps {
  fixedPosition?: boolean;
}

const Footer = ({ fixedPosition = false }: FooterProps) => {
    return (
        <StyledContainer className={fixedPosition ? "fixed-position" : ""}>
            <p>© 2026 Phervent Brands, Inc. All Rights Reserved.</p>
        </StyledContainer>
    );
};

export const StyledContainer = styled.div`
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #595959;
    font-size: x-small;
`;

export default Footer;
